import { AdminTrxServices } from '@/services/admin.trx.services'

const state = {
  loading: false,
  dialogsukseskan: false,
  dialog: false,
  overlay: false,
  trxadmin: [],
  totaltrxadmin: 0,
  sumtrx: [0, 0],
  selectedtrx: {
    id: '',
    transactionrc: 0,
    serialnumber: '',
    description: ''
  }
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setselectedtrx ({ commit }, item) {
    commit('setselectedtrx', item)
  },
  setdialogsukseskan ({ commit }, diag) {
    commit('setdialogsukseskan', diag)
  },
  getAdminTrx ({ commit }, opt) {
    commit('setloading', true)
    localStorage.setItem('admintrx_opsi', JSON.stringify(opt))
    AdminTrxServices.getAdminTrx(opt).then(value => {
      commit('setloading', false)
      commit('setdatatrx', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSumTrx ({ commit }) {
    commit('setloading', true)
    AdminTrxServices.getSumAdminTrx().then(value => {
      commit('setloading', false)
      commit('setdatasumtrx', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  updateStatusTrx ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminTrxServices.adminUpdateTrx(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Update Trx Ok!', { root: true })
      var s = JSON.parse(localStorage.getItem('admintrx_opsi'))
      if (s) {
        dispatch('getAdminTrx', s)
      }
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  sukseskanTrx ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminTrxServices.adminSukseskanTrx(data).then(value => {
      commit('setloading', false)
      commit('setdialogsukseskan', false)
      dispatch('alert/success', 'Update Trx Ok!', { root: true })
      var s = JSON.parse(localStorage.getItem('admintrx_opsi'))
      if (s) {
        dispatch('getAdminTrx', s)
      }
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogsukseskan (state, s) {
    state.dialogsukseskan = s
  },
  setdatatrx (state, s) {
    state.trxadmin = []
    state.trxadmin = s.data.content
    state.totaltrxadmin = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdatasumtrx (state, s) {
    state.sumtrx = [0, 0]
    state.sumtrx = s.data
    state.loading = false
    state.overlay = false
  },
  setselectedtrx (state, s) {
    state.selectedtrx = s
  }
}

export const TrxAdmin = {
  namespaced: true,
  state,
  actions,
  mutations
}
